
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"48","viewBox":"0 -960 960 960","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M481-330q-23 0-36.5-16T434-385q5-36 21.5-64t50.5-58q42-38 64.5-70.5t22.5-69.673Q593-692 562.856-722T479-752q-37 0-61.407 14.936Q393.186-722.128 378-700q-11 16-28 22t-33.286-.667Q297-687 292.5-708t6.5-38q28-41 73.415-67.5Q417.829-840 479-840q100.183 0 154.092 55.681Q687-728.639 687-650.59 687-603 666.5-564T601-482q-35 34-49 55t-18 48q-3 21-17.912 35-14.913 14-35.088 14zm-2.089 250Q450-80 429.5-100.589q-20.5-20.588-20.5-49.5Q409-179 429.589-199.5q20.588-20.5 49.5-20.5Q508-220 528.5-199.411q20.5 20.588 20.5 49.5Q549-121 528.411-100.5 507.823-80 478.911-80z"}})])
          )
        }
      }
    